// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6306":"320b3847f55da4e2","9166":"60e4237093095cf2"}[chunkId] + ".js";
};